<!--
  Zeigt die Country Manager des Reisetermins, nur lesend
  Ist keiner gesetzt, steht dort stattdessen eine Warnung
-->
<template>
  <div v-if="kuerzel.length" class="sidebar-country-manager">
    <span class="sidebar-country-manager__label">Country Manager</span>
    <div class="sidebar-country-manager__pills">
      <span
        v-for="cmKuerzel in kuerzel"
        :key="cmKuerzel"
        class="pill-badge pill-badge--small"
        :style="pillStyle"
      >
        {{ cmKuerzel }}
      </span>
    </div>
  </div>
  <div v-else class="sidebar-country-manager sidebar-country-manager--warnung" role="alert">
    <TriangleAlert :size="16" class="flex-shrink-0" />
    <span>
      Kein Country Manager gesetzt. Der Termin erscheint nicht im CM-Portal, und es gehen keine Aufgaben oder
      Mails an einen Country Manager.
    </span>
  </div>
</template>

<script>
import { TriangleAlert } from 'lucide-vue';
import { grauPillColors, pillColorStyleObject } from '@/core/common/helpers/utils';

export default {
  name: 'SidebarTerminplanungCountryManager',
  components: { TriangleAlert },
  props: {
    countryManagers: { type: Array, default: () => [] },
  },
  computed: {
    kuerzel() {
      return this.countryManagers.map(cm => cm.countryManagerKuerzel).filter(Boolean);
    },
    pillStyle() {
      return pillColorStyleObject(grauPillColors);
    },
  },
};
</script>

<style scoped>
.sidebar-country-manager {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  font-size: 14px;
  line-height: 20px;
}
.sidebar-country-manager__label {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--text-body);
}
.sidebar-country-manager__pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.sidebar-country-manager--warnung {
  gap: 8px;
  border-color: var(--danger);
  background-color: var(--restriktion-keine-abreise-hart-bg);
  color: var(--restriktion-keine-abreise-hart-text);
}
</style>
